import React from 'react';
import { ArrowLeft, Phone, Calendar } from 'lucide-react';
import { useNavigate, Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { ARTICLES } from '../data/articles';
import { useSEO } from '../hooks/useSEO';

const BlogPage = () => {
  const navigate = useNavigate();

  const articles = ARTICLES;

  useSEO({
    title: 'Blog réparation smartphone – Conseils iPhone & Samsung | Suro Phone Saint-Chamond',
    description: "Conseils d'un réparateur de Saint-Chamond : écran noir Samsung, protéger son iPhone, batterie qui gonfle, changer sa batterie. Astuces pour la Loire (42).",
    path: '/blog',
  });

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Navigation */}
      <nav className="bg-white shadow-sm sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 py-4 flex items-center justify-between">
          <button 
            onClick={() => navigate('/')}
            className="flex items-center gap-2 text-gray-700 hover:text-gray-900 transition-colors"
          >
            <ArrowLeft className="w-5 h-5" />
            <span>Retour</span>
          </button>
          
          <div className="flex items-center gap-4">
            <a href="tel:0773601521" className="flex items-center gap-2 text-gray-700 hover:text-gray-900 transition-colors">
              <Phone className="w-4 h-4" />
              <span className="font-medium">07.73.60.15.21</span>
            </a>
          </div>
        </div>
      </nav>

      {/* Header */}
      <section className="bg-gradient-to-br from-[#1a2332] to-[#1e2a3d] text-white py-16 px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Blog Suro Phone</h1>
          <p className="text-xl text-gray-300">Conseils et astuces pour l'entretien de votre smartphone</p>
        </div>
      </section>

      {/* Articles */}
      <div className="max-w-6xl mx-auto px-4 py-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {articles.map((article) => (
            <Card key={article.id} data-testid={`blog-card-${article.id}`} className="hover:shadow-xl transition-shadow overflow-hidden">
              <img 
                src={article.image} 
                alt={article.title}
                className="w-full h-48 object-cover" loading="lazy"
              />
              <CardContent className="p-6">
                <div className="flex items-center gap-4 text-sm text-gray-500 mb-3">
                  <span className="flex items-center gap-1">
                    <Calendar className="w-4 h-4" />
                    {article.date}
                  </span>
                  <span>{article.readTime} de lecture</span>
                </div>
                
                <h2 className="text-xl font-bold text-gray-900 mb-3">
                  {article.title}
                </h2>
                
                <p className="text-gray-600 mb-4">
                  {article.excerpt}
                </p>
                
                <Link to={`/blog/${article.id}`}>
                  <Button className="w-full bg-blue-500 hover:bg-blue-600 text-white">
                    Lire l'article
                  </Button>
                </Link>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>

      {/* CTA */}
      <section className="py-16 px-4 bg-blue-600 text-white">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl font-bold mb-6">Besoin de réparer votre téléphone ?</h2>
          <p className="text-xl mb-8">Contactez Suro Phone - Expert en réparation à Saint-Chamond</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href="tel:0773601521">
              <Button className="bg-white text-blue-600 hover:bg-gray-100 px-8 py-4 text-lg">
                <Phone className="w-5 h-5 mr-2" />
                07.73.60.15.21
              </Button>
            </a>
            <Link to="/rendez-vous">
              <Button className="bg-green-500 hover:bg-green-600 text-white px-8 py-4 text-lg">
                Prendre rendez-vous
              </Button>
            </Link>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-8 px-4">
        <div className="max-w-7xl mx-auto text-center">
          <p className="text-gray-400">© 2026 Suro Phone - Blog</p>
        </div>
      </footer>
    </div>
  );
};

export default BlogPage;